import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const RapportMissionService = {
      async detailsrapportmission(id){
        try {
            const result = await axios.get(`${apiUrl}/RapportMission/missionRapport/`+id );
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },
  async validatemission(id,validatestatus,status){
        try {
            const result = await axios.post(`${apiUrl}/RapportMission/getvalidate/`+id,{validatestatus:validatestatus,status:status});
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },

     async rapportmissiondetails(date_debut,date_fin,directiondest,directionid,serviceid,status,functionIds){
        try {
            const result = await axios.post(`${apiUrl}/RapportMission/getdetails/`,
            {
              date_debut:date_debut,
              date_fin:date_fin,
              directiondest:directiondest,
              directionid:directionid,
              serviceid:serviceid,
              status:status,
              functionIds:functionIds
            });
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },

     async detailshistory(mission_planning,planning_destination){
        try {
            const result = await axios.post(`${apiUrl}/RapportMission/detailsmission/`,
            {
              mission_planning:mission_planning,
              planning_destination:planning_destination
            });
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },

  }

export default RapportMissionService;